import { useGetMySummary } from "@/api/user/useGetMySummary";
import { useAuth } from "@/auth/AuthContext";
import { formatDateToYearMonth } from "@/utils/date";
import { Button, Stack, Text, Title } from "@mantine/core";
import { NavLink, useNavigate } from "react-router-dom";

export function HomeProfilePage() {
  const { data: user } = useGetMySummary();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/", { replace: true });
  };

  return (
    <Stack align="center" justify="center" h="100%" gap={40}>
      <Stack w="100%" align="center" pb="15vh">
        <Stack align="center" gap={4} mb="lg">
          <Title order={2} c="white">
            {user?.name}
          </Title>
          {user?.createdAt && (
            <Text c="dimmed" size="sm">
              {formatDateToYearMonth(user.createdAt)}부터 오프와 함께 하는 중
            </Text>
          )}
        </Stack>
        <Stack gap="md" w="100%" maw={400}>
          <Button
            component={NavLink}
            to="edit"
            variant="outline"
            size="lg"
            radius="md"
            color="gray"
            styles={(theme) => ({
              root: {
                color: theme.white,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              },
            })}
          >
            나의 프로필
          </Button>
          <Button
            component={NavLink}
            to="personality-test"
            variant="outline"
            size="lg"
            color="gray"
            radius="md"
            styles={(theme) => ({
              root: {
                color: theme.white,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              },
            })}
          >
            나의 취향 테스트
          </Button>
          <Button
            component={NavLink}
            to="help"
            variant="outline"
            size="lg"
            color="gray"
            radius="md"
            styles={(theme) => ({
              root: {
                color: theme.white,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              },
            })}
          >
            고객센터
          </Button>
          <Button
            onClick={handleSignOut}
            variant="filled"
            size="lg"
            color="red"
            radius="md"
            styles={(theme) => ({
              root: {
                color: theme.white,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              },
            })}
          >
            로그아웃
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
